<template>
    
    <div class="main_lay">
        <v-row>
            <v-col cols="12" md="12">
                <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="desserts"
                    class="elevation-1"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>{{title}}</v-toolbar-title>
                            <v-divider
                            class="mx-4"
                            inset
                            vertical
                            ></v-divider>
                            <v-row style="margin: 30px 0 0 0">
                                <v-col cols="12" md="8">
                                    <v-file-input v-model="file"  accept="" :label="$vuetify.lang.t('$vuetify.common.fileInput')" outlined dense></v-file-input>
                                </v-col>
                                <!-- <v-col cols="12" md="2"> -->
                                    <v-btn color="primary" dark  @click="sdkAdd" style="margin: 12px 0 0 0"><span style="color:#fff">{{$vuetify.lang.t('$vuetify.common.fileInput')}}</span></v-btn>
                                <!-- </v-col> -->
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <a class="span">
                            <v-icon
                                small
                                class="mr-2"
                                color='blue'
                                @click="deleteItem(item)"
                            >
                                {{$vuetify.lang.t('$vuetify.common.deleteBtn')}}
                            </v-icon>
                        </a>
                    </template>
                    <template v-slot:no-data>
                    </template> 
                </v-data-table>

                <v-dialog v-model="dialog" width="70%" height="20%">
                    <v-card>
                        <v-card-title class="headline">
                            <v-icon large color="red" style="margin:10px 10px 10px 0">mdi-car-brake-alert</v-icon>
                            <span style="color:red;margin:0 20px 0 0 ">{{$vuetify.lang.t('$vuetify.common.confirmdel')}}?</span>
                            {{$vuetify.lang.t('$vuetify.common.del_api_warning')}}
                        </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="dialog=false">
                                {{$vuetify.lang.t('$vuetify.userManage.close')}}
                            </v-btn>
                            <v-btn color="error" @click="handleDel" :loading="dialog_loading" :disabled="!dialog">
                                <span style="color:#fff">{{$vuetify.lang.t('$vuetify.userManage.confirm')}}</span>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            
                <!-- 加载块 -->
                <v-dialog
                    v-model="dialog_loading"
                    hide-overlay
                    persistent
                    width="300"
                    >
                    <v-card
                        color="primary"
                        dark
                    >
                        <v-card-text>
                        请等待
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>

            </v-col>
        </v-row>

    </div>

</template>

<script>
import bus from '../../utils/bus.js'
import Echarts from 'echarts'
import * as api from './../../api'
import { Notification  } from 'element-ui';
// import CsvExport from './../../utils/CsvExport'
export default {
    data () {
      return {
            file:[],
            dialog: false,
            dialog_loading: false,
            ns: '',
            del_loading: false,
            search: '',
            title: this.$vuetify.lang.t('$vuetify.apiManagement.tableName'),
            loading: false,
          
            headers: [
                { text: this.$vuetify.lang.t('$vuetify.apiManagement.name'), value: 'name' },
                { text: this.$vuetify.lang.t('$vuetify.apiManagement.sdkVersion'), value: 'version' },
                { text: this.$vuetify.lang.t('$vuetify.apiManagement.namespace'), value: 'ns' },
                { text: this.$vuetify.lang.t('$vuetify.apiManagement.action'), value: 'action' },
            ],
            desserts: [
            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
            },
            defaultItem: {
            },
        
      }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.portalMac.newItem') : this.$vuetify.lang.t('$vuetify.portalMac.editItem')
      },
    },
    watch: {
      dialog_loading (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 2000)
      },
    },

    created () {
      this.initialize()
    },
    mounted() {
        this.$nextTick(() => {
            this.getSdkList();
        })
    },
    methods: {
        getSdkList(){
            this.$http.get(api.default.sms.sdkList).then(resp => {
                this.desserts = resp.data
            }).finally(resp => {
                
            })
        },
        sdkAdd() {
            if(this.file == ''){
                return Notification({
                    type: 'waring',
                    message: this.$vuetify.lang.t('$vuetify.apiManagement.fileNull')
                });
            }else{
                var formData = new FormData();
                formData.append('sdk', this.file);

                this.$http.post(api.default.sms.sdkAdd,formData,{
                    headers: {'Content-Type': 'multipart/form-data'},
                }).then(resp => {
                    if(!resp){
                        return
                    }
                    this.getSdkList()
                    this.file = ''
                    return Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.common.success')
                    });

                }).finally(resp => {
                })
            }

            
        },
        handleExport(){
            // CsvExport(this.headers,this.desserts,this.title);
        },
        initialize() {

        },
        editItem (item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
        },

        deleteItem (item) {
            this.dialog = true
            this.ns = item.ns
        },

        handleDel() {
            this.dialog_loading = true

            setTimeout(() => {
                this.$http.get(api.default.sms.sdkDelete,{
                    params: {ns : this.ns}
                }).then(resp => {

                    this.getSdkList()
                    
                }).finally(resp => {
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.apiManagement.deleteSuccess')
                    });
                })
                this.dialog_loading = false
                this.dialog = false
            }, 1200);
            
            
        },

        close () {
            setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            }, 300)
        },

        save () {
            if (this.editedIndex > -1) {
            Object.assign(this.desserts[this.editedIndex], this.editedItem)
            } else {
            this.desserts.push(this.editedItem)
            }
            this.close()
        },

        getColor (item) {
            if (item == '是') return 'green'
            else return 'grey'
        },
        getColor1 (item) {
            if (item == '已开启') return 'green'
            else return 'grey'
        },
        busFunction(){
            
        },
    }
}
</script>

<style scoped>

.main_lay {
    margin: 0 24px;
    min-height: 90%;
    padding-bottom: 20px;
}

</style>